import "./ChangePasswordForm.css";
import Flex from "../Flex/Flex";
import Text from "../Text/Text";
import FormItem from "../FormItem/FormItem";
import Input from "../Input/Input";
import Button from "../Button/Button";
import LockIcon from "../../assets/Icons/LockIcon.svg?react";

import { Controller, useForm } from "react-hook-form";
import { changePassword } from "../../containers/UserProfilePage/actions";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

type FormValues = {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
};

const ChangePasswordForm = () => {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<FormValues>({});

  const onSubmit = handleSubmit(
    ({ oldPassword, newPassword, confirmNewPassword }) => {
      dispatch(
        changePassword({ oldPassword, newPassword, confirmNewPassword })
      );
    }
  );
  return (
    <Flex
      className="ChangePasswordForm"
      vertical
      gap={0}
    >
      <Flex
        className="ChangePasswordForm__Title"
        align="center"
      >
        <i className="ChangePasswordForm__TitleIcon">
          <LockIcon />
        </i>
        <Text
          size={4}
          bold
        >
          {t("password")}
        </Text>
      </Flex>

      <form
        className="ChangePasswordForm__Content"
        onSubmit={onSubmit}
      >
        <FormItem
          error={errors.oldPassword?.message}
          className="ChangePasswordForm__Input"
        >
          <Controller
            name="oldPassword"
            control={control}
            rules={{
              required: t("please_input_your_password"),
            }}
            render={({ field }) => (
              <Input
                placeholder={t("old_password")}
                autoComplete="off"
                type="password"
                aria-invalid={errors.oldPassword?.message ? true : false}
                {...field}
              />
            )}
          />
        </FormItem>
        <div className="ChangePasswordForm--horizontal-divider"></div>
        <FormItem
          error={errors.newPassword?.message}
          className="ChangePasswordForm__Input"
        >
          <Controller
            name="newPassword"
            control={control}
            rules={{
              required: t("required"),
            }}
            render={({ field }) => (
              <Input
                placeholder={t("new_password")}
                autoComplete="off"
                type="password"
                aria-invalid={errors.newPassword?.message ? true : false}
                {...field}
              />
            )}
          />
        </FormItem>
        <FormItem
          error={errors.confirmNewPassword?.message}
          className="ChangePasswordForm__Input"
        >
          <Controller
            name="confirmNewPassword"
            control={control}
            rules={{
              required: t("required"),
              validate: value => {
                if (watch("newPassword") !== value) {
                  return t("passwords_do_not_match");
                }
              },
            }}
            render={({ field }) => (
              <Input
                placeholder={t("confirm_password")}
                autoComplete="off"
                type="password"
                aria-invalid={errors.confirmNewPassword?.message ? true : false}
                {...field}
              />
            )}
          />
        </FormItem>
        <FormItem className="ChangePasswordForm__Action">
          <Button>{t("change")}</Button>
        </FormItem>
      </form>
    </Flex>
  );
};

export default ChangePasswordForm;
